import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as querystring from 'querystring';
import * as React from 'react';
import { API, EnrollResponse } from '../api/api';
import { reportError } from '../telemetry';
import { unreachable } from '../utils';
import { InjectAPI } from './app/app';
import { Spinner } from './widgets/spinner';

@inject('api')
@observer
class HomeInner extends React.Component<InjectAPI> {
  private readonly store: Store;

  constructor(props: InjectAPI) {
    super(props);
    this.store = new Store(props.api);
  }

  public componentWillMount() {
    const query = querystring.parse<HomeQuery>(location.search.slice(1));
    this.store.enrollUUID(query.booking_uuid).catch(reportError);
  }

  public render() {
    if (this.store.state === State.LOADING)
      return this.renderLoading();
    else if (this.store.state === State.SUCCESS)
      return this.renderSuccess();
    else if (this.store.state === State.ERROR)
      return this.renderError();
    else
      return unreachable(this.store.state);
  }

  private renderLoading() {
    return <Spinner/>;
  }

  private renderSuccess() {
    return (
      <div className="error container">
        <h1>Thanks for being flexible.</h1>
        <p>
          You’ve been added to the volunteer list and we’ll keep you posted.
          In the meantime, make your way to the gate for your scheduled flight.
        </p>
        <p>
          If you are chosen as a volunteer, the agents at the gate will provide options on flights to your destination.
        </p>
        <p className="small">
          <a target="_blank" href="https://www.alaskaair.com/">Visit alaskaair.com</a>
        </p>
      </div>
    );
  }

  private renderError() {
    return (
      <div className="error container">
        <h1>Thank you.</h1>
        <p>
          Thank you for your flexibility and interest. However, volunteers are no longer needed for this flight.
          Please continue as normal for your scheduled flight.
        </p>
        <p>
          We look forward to seeing you on board.
        </p>
        <p className="small">
          <a target="_blank" href="https://www.alaskaair.com/">Visit alaskaair.com</a>
        </p>
      </div>
    );
  }
}

export const Home = HomeInner as React.ComponentClass;

interface HomeQuery {
  readonly booking_uuid: string;
}

const enum State {
  LOADING, ERROR, SUCCESS,
}

class Store {
  @observable public state = State.LOADING;  // tslint:disable-line:readonly-keyword

  constructor(private readonly api: API) { }

  @action
  public async enrollUUID(uuid: string) {
    this.state = State.LOADING;

    try {
      this.handleEnrollResponse(await this.api.enroll(uuid));
    } catch (e) {
      reportError(e);
      this.handleEnrollResponse({ tag: 'unexpected-error' });
    }
  }

  @action
  private handleEnrollResponse(result: EnrollResponse) {
    this.state = result.tag === 'ok' ? State.SUCCESS : State.ERROR;
  }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/home.tsx